module.exports = __webpack_public_path__ + "media/images/icons/material/document-37cde7049b0040e7129b60e20e4dd8b8.svg";